import { render, staticRenderFns } from "./GradeDataDetailTable.vue?vue&type=template&id=2e07b104&scoped=true"
import script from "./GradeDataDetailTable.vue?vue&type=script&lang=ts"
export * from "./GradeDataDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./GradeDataDetailTable.vue?vue&type=style&index=0&id=2e07b104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e07b104",
  null
  
)

export default component.exports